import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';

@Component
export default class Aviso2faComponent extends Vue {
  @Prop({ default: 'modal-manuales' })
  modalId: string;

  public abrirGuia(): void {
    this.$bvModal.show(this.modalId);
  }
}
